const MASTER_KEY_NUDGE_PENDING_KEY = 'videocall.masterKeyNudgePending';
const MASTER_KEY_NUDGE_SHOWN_KEY = 'videocall.masterKeyNudgeShown';

function readFlag(key: string): boolean {
  try {
    return localStorage.getItem(key) === '1';
  } catch {
    return false;
  }
}

function writeFlag(key: string, value: boolean): void {
  try {
    if (value) {
      localStorage.setItem(key, '1');
    } else {
      localStorage.removeItem(key);
    }
  } catch {
    // ignore
  }
}

function hasPendingMasterKeyNudge(): boolean {
  return readFlag(MASTER_KEY_NUDGE_PENDING_KEY);
}

function hasShownMasterKeyNudge(): boolean {
  return readFlag(MASTER_KEY_NUDGE_SHOWN_KEY);
}

export function shouldShowMasterKeyNudge(): boolean {
  return hasPendingMasterKeyNudge() && !hasShownMasterKeyNudge();
}

export function markMasterKeyNudgePending(): void {
  if (hasShownMasterKeyNudge()) return;
  writeFlag(MASTER_KEY_NUDGE_PENDING_KEY, true);
}

export function consumeMasterKeyNudge(): void {
  writeFlag(MASTER_KEY_NUDGE_PENDING_KEY, false);
  writeFlag(MASTER_KEY_NUDGE_SHOWN_KEY, true);
}

export function clearMasterKeyNudge(): void {
  writeFlag(MASTER_KEY_NUDGE_PENDING_KEY, false);
}
